import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessorDirective } from '../../../Helpers/Directives/controlValueAccessor.directive';

@Component({
  selector: 'input-number',
  templateUrl: 'inputNumber.component.html',
  styleUrls: ['inputNumber.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputNumberComponent),
      multi: true,
    },
  ],
})
export class InputNumberComponent extends ControlValueAccessorDirective {
  @Input() placeholder: string = '';
  @Input() public readonly: boolean = false;

  constructor() {
    super();
  }

  blurHandler() {
    this.blur();
  }
}
